"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJsonFormErrors = void 0;
const core_1 = require("@jsonforms/core");
const react_1 = require("@jsonforms/react");
const react_2 = require("react");
const useJsonFormErrors = (path) => {
    const { core } = (0, react_1.useJsonForms)();
    const [isValid, setIsValid] = (0, react_2.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_2.useState)();
    (0, react_2.useEffect)(() => {
        var _a;
        const errors = (_a = core === null || core === void 0 ? void 0 : core.errors) === null || _a === void 0 ? void 0 : _a.filter(e => (0, core_1.getControlPath)(e) === path);
        const hasErrors = (core === null || core === void 0 ? void 0 : core.validationMode) === "ValidateAndShow" && errors && errors.length > 0;
        setIsValid(!hasErrors);
        setErrorMessage(hasErrors ? errors[0].message : undefined);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [core === null || core === void 0 ? void 0 : core.errors]);
    return {
        isValid,
        errorMessage,
    };
};
exports.useJsonFormErrors = useJsonFormErrors;
